import { Pipe, PipeTransform } from "@angular/core";
import { gregorianAge } from "@vp/shared/utilities";

@Pipe({
  name: "age",
  standalone: false
})
export class AgePipe implements PipeTransform {
  transform(dateOfBirth: string): unknown {
    if (!dateOfBirth) return "";

    const birth = new Date(dateOfBirth);

    if (isNaN(birth.getTime())) return "";

    const now = new Date();
    const age = gregorianAge(dateOfBirth, now);

    if (age > 0) return age.toString();

    let months =
      (now.getFullYear() - birth.getFullYear()) * 12 + (now.getMonth() - birth.getMonth());

    if (now.getDate() < birth.getDate()) {
      months -= 1;
    }

    const displayMonths = Math.max(0, months);
    return `${displayMonths} mo`;
  }
}
